import { observer }              from 'mobx-react';
import { useEffect }             from 'react';
import { notificationsSidebar }  from '@stonecode/notifications-sidebar';
import Alert                     from '@widesk-ui/components/Alert';
import Button                    from '@widesk-ui/components/Button';
import Title                     from '@widesk-ui/components/Title';
import Tooltip                   from '@widesk-ui/components/Tooltip';
import View                      from '@widesk-ui/components/View';
import useTheme                  from '@widesk-ui/hooks/useTheme';
import useApiCollection          from '@widesk-core/hooks/useApiCollection';
import UserAccountModel          from '@/models/services/account/UserAccountModel';
import useAccount                from '@/hooks/useAccount';
import useDesignTokens           from '@/hooks/useDesignTokens';
import appStore                  from '@/stores/appStore';

const AccountName = (props: { name: string }) => {
	const theme = useTheme();

	return (
		<Tooltip title={props.name}>
			<span
				style={{
					fontSize: theme.fontSizeHeading5,
					fontWeight: 'bold',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
				}}
			>
				{props.name}
			</span>
		</Tooltip>
	);
};

const AccountWall = observer(() => {
	const tokens = useDesignTokens();
	const userAccountCollection = useApiCollection(UserAccountModel);

	useEffect(() => {
		(async () => {
			if (appStore.user.urn) {
				await userAccountCollection.listBy(appStore.user.urn, 'user');
				await userAccountCollection.whenIsLoaded(m => [m.account, m.account.accountStatus]);
				notificationsSidebar.watchTrigger();
			}
		})();
	}, [appStore.user.urn]);

	const { selectAccount } = useAccount();

	useEffect(() => {
		if (userAccountCollection.length !== 1) return;

		const accountId = userAccountCollection.first()!.account.id;

		if (accountId !== appStore.failedAccountId) selectAccount(accountId);
	}, [userAccountCollection.length]);

	return (
		<View heightF center padding="lg">
			<View gap="sm" center style={{ width: '100%', maxWidth: 420 }}>
				<Title level={2} bold align="center">Bonjour&nbsp;{appStore.user.modelLabel}</Title>
				<Title level={5} color={tokens.text.secondary} marginB="lg">Sélectionnez un compte</Title>
				{appStore.failedAccountId && (
					<Alert type="error" showIcon message="Impossible d'accéder à ce compte." style={{ width: '100%' }} />
				)}
				<View className="account-wall__container" widthF gap="sm">
					{userAccountCollection.map(userAccount => {
						const account = userAccount.account;

						return (
							<View
								row
								space="between"
								center
								key={account.id}
								bg={tokens.surface.card}
								padding="lg"
								br={8}
								style={{ boxShadow: tokens.shadow.card }}
								gap="sm"
							>
								<View flex gap="xxs" style={{ minWidth: 0 }}>
									{account.name
										? <AccountName name={account.name} />
										: <Title marginB={0} level={5} bold>{account.renderName()}</Title>}
									{account.accountStatus.renderName()}
								</View>
								<View marginL="lg" style={{ flexShrink: 0 }}>
									<Button onClick={() => selectAccount(account.id)} type="primary">Sélectionner</Button>
								</View>
							</View>
						);
					})}
				</View>
			</View>
		</View>
	);
});

export default AccountWall;
